import axios from "axios";
import { API_URL } from "../config";
import api from "./api";
import authService from "./auth";

const empreendimentoService = {
  listarPaginado: async (filtros = {}, pageNumber = 1, pageSize = 10) => {
    const params = Object.fromEntries(
      Object.entries({ ...filtros, pageNumber, pageSize }).filter(
        ([_, value]) => value !== "" && value != null
      )
    );

    const response = await axios.get(`${API_URL}empreendimento/filtrar`, {
      headers: authService.getAuthHeader(),
      params,
    });

    if (Array.isArray(response.data)) {
      return {
        items: response.data,
        totalCount: response.data.length,
        pageNumber,
        pageSize,
        totalPages: Math.ceil(response.data.length / pageSize),
      };
    }

    if (Array.isArray(response.data?.data)) {
      const pagination = response.data?.pagination || {};
      return {
        items: response.data.data,
        totalCount: pagination.totalCount ?? response.data.data.length,
        pageNumber: pagination.pageNumber ?? pageNumber,
        pageSize: pagination.pageSize ?? pageSize,
        totalPages:
          pagination.totalPages ??
          Math.ceil((pagination.totalCount ?? response.data.data.length) / pageSize),
      };
    }

    return {
      items: [],
      totalCount: 0,
      pageNumber,
      pageSize,
      totalPages: 0,
    };
  },

  listar: async (filtros = {}) => {
    const params = Object.fromEntries(
      Object.entries(filtros).filter(
        ([_, value]) => value !== "" && value != null
      )
    );

    const response = await axios.get(`${API_URL}empreendimento/filtrar`, {
      headers: authService.getAuthHeader(),
      params,
    });

    if (Array.isArray(response.data)) {
      return response.data;
    }

    if (Array.isArray(response.data?.data)) {
      return response.data.data;
    }

    return [];
  },

  obter: async (id) => {
    try {
      const response = await axios.get(`${API_URL}empreendimento/${id}/`, {
        headers: authService.getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { detail: "Erro ao obter empreendimento" };
    }
  },

  obterPorId: async (id) => {
    try {
      const response = await axios.get(`${API_URL}Empreendimento/${id}`, {
        headers: authService.getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { detail: "Erro ao obter empreendimento" };
    }
  },

  obterPorCnpj: async (cnpj) => {
    try {
      const response = await api.get("Empreendimento/por-cnpj", {
        params: { cnpj },
      });
      const data = response.data?.data ?? response.data;
      if (Array.isArray(data)) return data;
      if (data && typeof data === "object") return [data];
      return [];
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Erro ao buscar empreendimento pelo CPF/CNPJ.";
      const notFound = error.response?.status === 404;
      const err = new Error(message);
      err.notFound = notFound;
      err.response = error.response;
      throw err;
    }
  },

  criar: async (dados) => {
    try {
      const response = await axios.post(`${API_URL}empreendimento/`, dados, {
        headers: {
          ...authService.getAuthHeader(),
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  atualizar: async (id, dados) => {
    delete dados.municipio;
    delete dados.estado;
    delete dados.cep;

    try {
      const response = await axios.put(`${API_URL}empreendimento/`, dados, {
        headers: authService.getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || { detail: "Erro ao atualizar empreendimento" }
      );
    }
  },

  excluir: async (id) => {
    try {
      await axios.delete(`${API_URL}empreendimento/${id}/`, {
        headers: authService.getAuthHeader(),
      });
    } catch (error) {
      throw (
        error.response?.data || { detail: "Erro ao excluir empreendimento" }
      );
    }
  },

  verificarElegibilidadeCertidaoAutomatica: async (id) => {
    try {
      const response = await axios.get(
        `${API_URL}empreendimento/${id}/certidao-automatica/elegibilidade`,
        { headers: authService.getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          detail: "Erro ao verificar elegibilidade",
        }
      );
    }
  },
};

export default empreendimentoService;
